export default {"src":"/_next/static/media/logo-6.a3634471.svg","height":51,"width":38,"blurWidth":0,"blurHeight":0};